import { Component, ChangeDetectionStrategy, Inject } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { TranslateService } from '@ngx-translate/core'
import { ItemTypeEnum } from 'libs/gb-front/item/data-access/src'
import { ItemEntity } from 'libs/gb-front/selected-item/data-access/src/lib/+state/selected-item.models'
import { ProfileEntity } from 'libs/gb-front/selected-profile/data-access/src'

export type itemTypeParam = { type: ItemTypeEnum }
export interface GuestConfirmationDialogConfig {
  item: ItemEntity
  paymentAmount: number
  profile: ProfileEntity
}

@Component({
  selector: 'gb-select-guest-confirmation-dialog',
  templateUrl: './gb-select-guest-confirmation-dialog.component.html',
  styleUrls: ['./gb-select-guest-confirmation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbSelectGuestConfirmationDialogComponent {
  itemTypeTranslationMap = {
    [ItemTypeEnum.Bidding]: 'VOLUNTEER.CONFIRMATION_DIALOG.BID',
    [ItemTypeEnum.Donation]: 'VOLUNTEER.CONFIRMATION_DIALOG.DONATION',
    [ItemTypeEnum.Purchase]: 'VOLUNTEER.CONFIRMATION_DIALOG.PURCHASE',
    [ItemTypeEnum.Raffle]: 'VOLUNTEER.CONFIRMATION_DIALOG.RAFFLE_PURCHASE',
  }

  get itemTypeParam(): itemTypeParam {
    return {
      type: this.translateService.instant(this.itemTypeTranslationMap[this.data.item.item_type]),
    }
  }

  constructor(
    private translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: GuestConfirmationDialogConfig,
  ) {}
}
